// Core Modules
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

// Services
import { ErrorHandlerService } from '@core/services/error-handler/error-handler.service';

// Models
import { GenericErrorHandlerModel } from '@shared/models/generic-error-handler.model';

// Enums
import { ErrorHandlerCodesEnum } from '@shared/enum/error-handler-codes.enum';

@Component({
  selector: 'app-unauthorized',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent implements OnInit {
  // Injectors
  private readonly errorHandlerService = inject(ErrorHandlerService);

  // Private Members
  private readonly accessDeniedStatusCode: number = ErrorHandlerCodesEnum.FORBIDDEN;

  // Public Members
  public errorhandlerData?: GenericErrorHandlerModel;

  public ngOnInit(): void {
    this.errorhandlerData = this.errorHandlerService.getErrorCodeData(this.accessDeniedStatusCode);
  }
}
